<div id="footer__container">
  <span>{{ applicationVersion }}</span>
</div>
